export function possibleLVO(finalResult) {
  switch (finalResult.scaleUsed) {
    case 'LAMS':
      return finalResult.lamsScore > 3 ? 'YES' : 'NO';
    case 'RACE':
      return finalResult.raceScore > 4 ? 'YES' : 'NO';
    default:
      return 'Uknown';
  }
}

export function scaleValue(finalResult) {
  switch (finalResult.scaleUsed) {
    case 'LAMS':
      return finalResult.lamsScore;
    case 'RACE':
      return finalResult.raceScore;
    default:
      return '';
  }
}
